import { FC, useState } from 'react';

import { defaults } from '../constants';
import { PaginationContext, PaginationContextState } from 'utils/contexts/pagination';

export const PanelPaginationContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [pageSize, setPageSize] = useState(defaults.pageSize);
  const [currentPage, setCurrentPage] = useState(1);

  const context: PaginationContextState = {
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
  };

  return <PaginationContext.Provider value={context}>{children}</PaginationContext.Provider>;
};
